import React from "react";
import { FaTimes } from "react-icons/fa";
import Location from "./Location";

function EnteredLocation(props: {
  location: Location;
  idx: number;
  onDelete: (idx: number) => void;
}) {
  return (
    <div className="mt-1 flex h-9 items-center rounded-lg border border-gray-200 bg-gray-50">
      <p className="!m-0 w-full truncate px-3 text-sm text-gray-600">
        {props.location.name}
      </p>
      <button
        type="button"
        aria-label="Remove location"
        className="flex h-full w-9 shrink-0 items-center justify-center rounded-r-lg text-gray-300 hover:bg-red-50 hover:text-red-500"
        onClick={() => props.onDelete(props.idx)}
      >
        <FaTimes />
      </button>
    </div>
  );
}

export default EnteredLocation;
